import { Box, Button, IconButton, Modal, Typography } from '@material-ui/core';
import React from 'react';
import { BiX } from 'react-icons/bi';
import { IoIosWarning } from 'react-icons/io';
import { Content, Header } from './styles';
import stylesMaterial from './stylesMaterial';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  handleClose: () => void;
  handleDelete: () => void;
}

export function ConfirmDeleteModal({ isOpen, handleClose, handleDelete }: ConfirmDeleteModalProps) {
  const classes = stylesMaterial();

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      className={classes.modal}
      style={{ zIndex: 99999999991 }}
    >
      <Box className={classes.container}>
        <Header>
          <IconButton
            onClick={handleClose}
            aria-label="close modal"
            className={classes.closeButton}
          >
            <BiX size="22px" />
          </IconButton>
        </Header>

        <Content>
          <Box className={classes.warningIconWrapper}>
            <IoIosWarning 
              color="#f64444"
              fontSize="3.125rem"
            />
          </Box>
          
          <Typography
            id="modal-title"
            variant="h1"
            className={classes.title}
          >
            Atenção
          </Typography>

          <Typography 
            id="modal-description"
            className={classes.description}
          >
            Tem certeza que deseja deletar o complemento?
          </Typography>

          <Button
            fullWidth
            onClick={handleDelete} 
            className={`${classes.button} ${classes.confirmButton}`}
          >
            Confirmar
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={handleClose} 
            className={`${classes.button} ${classes.cancelButton}`}
          >
            Cancelar
          </Button>
        </Content>
      </Box>
    </Modal>
  );
}